module.exports = __webpack_public_path__ + "img/ic_nat_home_appointment.79c58407.png";